<div class="container-fluid usersPage py-3">
  <div class="row">

    <div class="col-12">

      <p-table #dt
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} usuarios"
        [filterDelay]="0"
        [first]="first"
        [lazy]="true"
        [paginator]="true"
        [rows]="25"
        [rowHover]="true"
        [rowsPerPageOptions]="[25, 50, 100]"
        [showCurrentPageReport]="!appUserService.loading"
        [totalRecords]="appUserService.total"
        [value]="tableValue"
        (onLazyLoad)="onLazyLoad($event)">

        <!-- ---------------------------------------------------------------- -->
        <!--                          ANCHOR CAPTION                          -->
        <!-- ---------------------------------------------------------------- -->
        <ng-template pTemplate="caption">
          <div class="container-fluid px-0">

            <!-- Un solo row: el responsive se resuelve con col-12 col-lg-*,
                 no abriendo filas extra. -->
            <div class="row g-2 align-items-center">

              <div class="col-12 col-lg placeholder-glow">
                <h1 class="usersPage__title mb-1">Usuarios</h1>

                @if (appUserService.loading) {
                  <span
                    class="placeholder col-5 rounded d-inline-block usersPage__skeletonText"
                    aria-hidden="true">
                  </span>
                } @else {
                  <p class="usersPage__subtitle mb-0">
                    {{ appUserService.total }}
                    {{ appUserService.total === 1
                        ? 'usuario encontrado'
                        : 'usuarios encontrados' }}
                    @if (appliedSearch) {
                      <span class="usersPage__subtitleTerm">
                        para «{{ appliedSearch }}»
                      </span>
                    }
                  </p>
                }
              </div>

              <!-- La caja de búsqueda es un <form>: así el Enter del teclado
                   envía igual que el botón, sin un (keyup.enter) suelto. -->
              <div class="col-12 col-lg-auto">
                <form
                  (ngSubmit)="search()"
                  class="d-flex align-items-center gap-2 usersPage__searchForm"
                  role="search">

                  <label
                    class="visually-hidden"
                    for="usersPageSearch">
                    Buscar usuario por nombre, usuario o correo
                  </label>

                  <div class="input-group usersPage__searchGroup">
                    <span
                      class="input-group-text usersPage__searchIcon"
                      aria-hidden="true">
                      <i class="material-icons">search</i>
                    </span>
                    <input
                      [(ngModel)]="searchTerm"
                      class="form-control usersPage__searchInput"
                      id="usersPageSearch"
                      name="searchTerm"
                      placeholder="Nombre, usuario o correo"
                      type="search">
                  </div>

                  <button
                    type="submit"
                    class="btn btn-primary usersPage__searchBtn"
                    [disabled]="appUserService.loading">
                    Buscar
                  </button>

                  <!-- Solo aparece cuando hay un término aplicado: sin búsqueda
                       activa no hay nada que limpiar. -->
                  @if (appliedSearch) {
                    <button
                      (click)="clearSearch()"
                      type="button"
                      class="btn btn-light usersPage__searchBtn"
                      [disabled]="appUserService.loading">
                      Limpiar
                    </button>
                  }

                </form>
              </div>

            </div>
          </div>
        </ng-template>

        <!-- ---------------------------------------------------------------- -->
        <!--                          ANCHOR HEADER                           -->
        <!-- ---------------------------------------------------------------- -->
        <!-- Sin ordenamiento por columnas: la lista la pagina y la ordena el
             servidor, y una flecha que no ordena nada miente. -->
        <ng-template pTemplate="header">
          <tr>
            <th>Usuario</th>
            <th class="d-none d-lg-table-cell">Nombre</th>
            <th class="d-none d-lg-table-cell">Correo</th>
            <th>Perfil</th>
            <th class="d-none d-lg-table-cell">Último acceso</th>
            <th class="d-none d-lg-table-cell">Alta</th>
          </tr>
        </ng-template>

        <!-- ---------------------------------------------------------------- -->
        <!--                           ANCHOR BODY                            -->
        <!-- ---------------------------------------------------------------- -->
        <ng-template pTemplate="body" let-user>

          @if (appUserService.loading) {

            <!-- Esqueleto por celda: reserva el alto final de la fila para que
                 la tabla no salte al llegar los datos. -->
            <tr class="placeholder-glow" aria-hidden="true">
              <td>
                <span class="placeholder col-8 rounded d-block usersPage__skeletonCell"></span>
              </td>
              <td class="d-none d-lg-table-cell">
                <span class="placeholder col-7 rounded d-block usersPage__skeletonCell"></span>
              </td>
              <td class="d-none d-lg-table-cell">
                <span class="placeholder col-8 rounded d-block usersPage__skeletonCell"></span>
              </td>
              <td>
                <span class="placeholder col-6 rounded d-block usersPage__skeletonCell"></span>
              </td>
              <td class="d-none d-lg-table-cell">
                <span class="placeholder col-6 rounded d-block usersPage__skeletonCell"></span>
              </td>
              <td class="d-none d-lg-table-cell">
                <span class="placeholder col-6 rounded d-block usersPage__skeletonCell"></span>
              </td>
            </tr>

          } @else {

            <!-- Fila-enlace: el clic en cualquier celda abre las propiedades del
                 usuario, igual que el enlace del nombre. Se conserva el rol
                 nativo de fila (no se pisa con role="button") para no romper la
                 navegación por tabla del lector de pantalla; la fila se anuncia
                 con aria-label y se activa con Enter o Espacio, y el enlace del
                 username sigue siendo la salida semántica de la acción. -->
            <tr
              (click)="goToUser(user)"
              (keydown.enter)="goToUser(user, $event)"
              (keydown.space)="goToUser(user, $event)"
              class="p-selectable-row usersPage__row"
              tabindex="0"
              [attr.aria-label]="'Ver las propiedades del usuario ' + user.username">

              <td>
                <div class="d-flex flex-column usersPage__cell">

                  <!-- Enlace real, alcanzable por teclado y con foco visible.
                       Detiene la propagación: el clic le pertenece al enlace y
                       no debe disparar además la navegación de la fila. -->
                  <a
                    (click)="$event.stopPropagation()"
                    [routerLink]="[user.uid]"
                    class="usersPage__username text-truncate"
                    [attr.aria-label]="'Ver las propiedades del usuario ' + user.username">
                    {{ user.username }}
                  </a>

                  <!-- En < lg aquí baja lo que las columnas ocultas ya no
                       muestran. -->
                  <span class="usersPage__cellMeta d-lg-none text-truncate">
                    @if (user.personName) {
                      {{ user.personName }}
                    } @else {
                      Sin nombre capturado
                    }
                  </span>

                  <span class="usersPage__cellMeta d-lg-none text-truncate">
                    @if (user.hasEmail) {
                      {{ user.email }}
                    } @else {
                      Sin correo
                    }
                  </span>

                  <span class="usersPage__cellMeta d-lg-none text-truncate">
                    @if (user.hasLoggedIn) {
                      Último acceso {{ user.lastLoginAt | dateToMoment: 'DD MMM YYYY HH:mm' }}
                    } @else {
                      Nunca ha iniciado sesión
                    }
                  </span>

                </div>
              </td>

              <td class="d-none d-lg-table-cell">
                @if (user.personName) {
                  <span class="usersPage__cellText">{{ user.personName }}</span>
                } @else {
                  <!-- Campo sin capturar: gris + texto explícito, nunca rojo. -->
                  <span class="usersPage__cellOff">Sin nombre capturado</span>
                }
              </td>

              <td class="d-none d-lg-table-cell">
                @if (user.hasEmail) {
                  <span class="usersPage__cellText text-break">{{ user.email }}</span>
                } @else {
                  <span class="usersPage__cellOff">Sin correo</span>
                }
              </td>

              <td>
                <!-- El perfil se lee por texto; el color solo acompaña. -->
                <span
                  class="usersPage__badge"
                  [class.usersPage__badge--sudo]="user.isSudo">
                  <i class="material-icons usersPage__badgeIcon" aria-hidden="true">
                    {{ user.isSudo ? 'shield' : 'person' }}
                  </i>
                  {{ user.profileLabel }}
                </span>
              </td>

              <td class="d-none d-lg-table-cell">
                @if (user.hasLoggedIn) {
                  <span class="usersPage__cellText">
                    {{ user.lastLoginAt | dateToMoment: 'DD MMM YYYY HH:mm' }}
                  </span>
                } @else {
                  <!-- Nunca entró NO es un error: gris, nunca rojo. -->
                  <span class="usersPage__cellOff">Nunca ha iniciado sesión</span>
                }
              </td>

              <td class="d-none d-lg-table-cell">
                <span class="usersPage__cellText">
                  {{ user.createdAt | dateToMoment: 'DD MMM YYYY HH:mm' }}
                </span>
              </td>

            </tr>

          }

        </ng-template>

        <!-- ---------------------------------------------------------------- -->
        <!--                        ANCHOR EMPTY STATE                        -->
        <!-- ---------------------------------------------------------------- -->
        <!-- Dos pantallas distintas: sin resultados para el término, o catálogo
             vacío. Ninguna es un error, así que ninguna va en rojo. -->
        <ng-template pTemplate="emptymessage">
          @if (!appUserService.loading) {
            <tr>
              <td colspan="6">
                <div class="usersPage__emptyState d-flex flex-column align-items-center justify-content-center text-center">

                  @if (isSearchEmpty) {

                    <i class="material-icons usersPage__emptyIcon" aria-hidden="true">search_off</i>
                    <p class="usersPage__emptyTitle mb-1">
                      Sin resultados para «{{ appliedSearch }}»
                    </p>
                    <p class="usersPage__emptyText mb-3">
                      Revisa la escritura del nombre, el usuario o el correo, o
                      limpia la búsqueda para ver todos los usuarios.
                    </p>
                    <button
                      (click)="clearSearch()"
                      type="button"
                      class="btn btn-outline-primary usersPage__emptyBtn">
                      Limpiar búsqueda
                    </button>

                  } @else {

                    <i class="material-icons usersPage__emptyIcon" aria-hidden="true">people_outline</i>
                    <p class="usersPage__emptyTitle mb-1">Aún no hay usuarios</p>
                    <p class="usersPage__emptyText mb-0">
                      Los usuarios se dan de alta desde la colonia a la que
                      pertenecen y aparecerán aquí en cuanto existan.
                    </p>

                  }

                </div>
              </td>
            </tr>
          }
        </ng-template>

      </p-table>

    </div>

    <!-- ------------------------------------------------------------------ -->
    <!--                        ANCHOR LIVE REGION                          -->
    <!-- ------------------------------------------------------------------ -->
    <!-- Vive siempre en el DOM: un aria-live que aparece junto con su texto no
         se anuncia. -->
    <div class="col-12 visually-hidden" role="status" aria-live="polite">
      {{ liveMessage }}
    </div>

  </div>
</div>
